import moment from 'moment'
import {Trans} from 'react-i18next'

import {useShutdowns} from '@refra/modules/common/providers'
import {useKilnShutdownsRefractories} from '@refra/modules/refra-planning/providers'
import type {MaterialInstallation} from '@refra/modules/refra-planning/types'

interface InstallationChartTooltipProps {
  materialInstallation: MaterialInstallation
  shutdownId: number
}

export const InstallationChartTooltip: React.FC<InstallationChartTooltipProps> = ({
  materialInstallation,
  shutdownId
}) => {
  const {activeShutdowns} = useShutdowns()
  const shutdown = activeShutdowns.find((shutdown) => shutdown.id === shutdownId)

  const {kilnShutdownsRefractories} = useKilnShutdownsRefractories()
  const refractory = kilnShutdownsRefractories[materialInstallation.refractoryId]

  const interventionDate = shutdown?.interventionDate
    ? moment(shutdown.interventionDate).format('DD.MM.YYYY')
    : null

  return (
    <div className="bg-gray-900 text-white p-4 rounded-md" data-cy="material_installation_tooltip">
      <div className="pb-1" data-cy="material_installation_tooltip_title">
        <Trans
          i18nKey="refraPlanning.materialInstallations.tooltip.shutdown"
          values={{
            name: shutdown?.name
          }}
        />
        <div>{`(${interventionDate})`}</div>
      </div>
      <ul className="list-disc list-inside pl-2" data-cy="material_installation_tooltip_list">
        <li data-cy="material_installation_tooltip_from_to">
          <Trans
            i18nKey="refraPlanning.materialInstallations.tooltip.fromToInfo"
            values={{
              fromMeter: materialInstallation.fromMeter,
              toMeter: materialInstallation.toMeter
            }}
          />
        </li>
        <li data-cy="material_installation_tooltip_material">
          <Trans
            i18nKey="refraPlanning.materialInstallations.tooltip.material"
            values={{
              material: refractory.name
            }}
          />
        </li>
        <li data-cy="material_installation_tooltip_supplier">
          <Trans
            i18nKey="refraPlanning.materialInstallations.tooltip.supplier"
            values={{
              supplier: refractory.manufacturer.name
            }}
          />
        </li>
        {materialInstallation.performance.heatZones?.map((heatZonePerformance) => (
          <li key={heatZonePerformance.heatZone} data-cy="material_installation_tooltip_heatZone">
            <Trans
              i18nKey="refraPlanning.materialInstallations.tooltip.heatZonePerformance"
              values={{
                name: heatZonePerformance.heatZone,
                minDays: heatZonePerformance.survivedDays.min,
                maxDays: heatZonePerformance.survivedDays.max
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
